var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2853 0 30 6.71468 30 15C30 23.2853 23.282 30 15 30C6.71799 30 0 23.282 0 15C0 6.71799 6.71468 0 15 0ZM12.8573 17.6839L21.4442 9.09703L22.9594 10.6123L14.3726 19.1991L14.3733 19.1998L12.858 20.715L7.55474 15.4117L9.06998 13.8965L12.8573 17.6839ZM2.14286 15C2.14286 7.90115 7.8983 2.14286 15 2.14286C22.1017 2.14286 27.8571 7.8983 27.8571 15C27.8571 22.1017 22.0989 27.8571 15 27.8571C7.90115 27.8571 2.14286 22.0989 2.14286 15Z",
    fill: "#6BC10E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon_success.dacdb4f9d674efbd58c6fb62920bd2ff.svg";
export { ForwardRef as ReactComponent };